import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
  accountListStyle: { alignSelf: 'stretch' },
  modalContainer: {
    marginHorizontal: 10,
  },
});
export default styles;
